import { NavigateBeforeOutlined, NavigateNextOutlined } from '@mui/icons-material';
import { Box, Fab, Pagination, Zoom } from '@mui/material';
import React from 'react';

function CamerasCarouselPagination({
  page,
  setPage,
  rowsPerPage,
  countPage,
}: {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  countPage: number;
}) {
  if (countPage <= 1) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Pagination
        size="small"
        count={countPage}
        page={page + 1}
        onChange={(event: React.ChangeEvent<unknown>, value: number) => {
          setPage(value - 1);
        }}
      />
    </Box>
  );
}

CamerasCarouselPagination.NavigateBefore = function NavigateBefore({
  page,
  setPage,
  hovering,
}: {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  hovering: boolean;
}) {
  return (
    <Zoom in={hovering && page > 0}>
      <Fab
        size="small"
        aria-label="previous"
        onClick={() => setPage(page - 1)}
        color="primary"
        sx={{
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          left: '-10px',
          zIndex: 'tooltip',
        }}
      >
        <NavigateBeforeOutlined />
      </Fab>
    </Zoom>
  );
};

CamerasCarouselPagination.NavigateNext = function NavigateNext({
  page,
  setPage,
  hovering,
  countPage,
}: {
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  hovering: boolean;
  countPage: number;
}) {
  return (
    <Zoom in={hovering && page !== countPage - 1}>
      <Fab
        size="small"
        aria-label="previous"
        onClick={() => setPage(page + 1)}
        color="primary"
        sx={{
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          right: '-10px',
          zIndex: 'tooltip',
        }}
      >
        <NavigateNextOutlined />
      </Fab>
    </Zoom>
  );
};

export default CamerasCarouselPagination;
